module.exports = __webpack_public_path__ + "img/gravity-lens.df1e8c47.png";